import { useState } from "react";
import { FaTimes, FaHeart, FaHandHoldingHeart, FaBuilding } from "react-icons/fa";
import "./DonatieModal.css";

const SUME = [25, 50, 100];

export default function DonatieModal({ onClose }) {
  const [loading, setLoading] = useState(false);
  const [sumaSelectata, setSumaSelectata] = useState(null);

  const handleDonatie = async (suma) => {
    setLoading(true);
    setSumaSelectata(suma);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/stripe/checkout`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ suma }),
        }
      );
      const { url } = await res.json();
      window.location.href = url;
    } catch (err) {
      alert("Eroare: " + err.message);
      setLoading(false);
    }
  };

  return (
    <div className="donatie-overlay" onClick={onClose}>
      <div className="donatie-modal" onClick={(e) => e.stopPropagation()}>

        <button className="donatie-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="donatie-header">
          <FaHeart size={40} color="#f4b400" />
          <h2>Ajută animalele fără stăpân</h2>
          <p>
            Fiecare donație contează. Împreună putem ajuta mai multe animale
            să ajungă acasă și să sprijinim asociațiile care le îngrijesc.
          </p>
        </div>

        <div className="donatie-split-info">
          <div className="split-item">
            <FaBuilding size={24} color="#f4b400" />
            <div>
              <strong>50%</strong>
              <span>Dezvoltarea FindMyPet</span>
            </div>
          </div>
          <div className="split-divider" />
          <div className="split-item">
            <FaHandHoldingHeart size={24} color="#f4b400" />
            <div>
              <strong>50%</strong>
              <span>Asociații pentru animale</span>
            </div>
          </div>
        </div>

        <div className="donatie-sume">
          {SUME.map((suma) => (
            <button
              key={suma}
              className={`donatie-suma-btn ${sumaSelectata === suma ? "activ" : ""}`}
              onClick={() => handleDonatie(suma)}
              disabled={loading}
            >
              {loading && sumaSelectata === suma ? "..." : `${suma} Lei`}
            </button>
          ))}
        </div>

        <p className="donatie-footer">
          Plată securizată prin Stripe 🔒
        </p>

      </div>
    </div>
  );
}